import type React from 'react'
import { useNavigate } from 'react-router-dom'
import { Home } from 'lucide-react'
import logo from '../assets/brit-logo.svg'
import homeBackground from '../assets/home-background.svg'
import loginDashboard from '../assets/loginDashboard.svg'
import ToggledImage from '../assets/toggled.svg'
interface AuthLayoutProps {
  children: React.ReactNode
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  const navigate = useNavigate()

  return (
    <div className='h-screen bg-[#FFFFFF] flex overflow-hidden'>
      {/* Center Content Area */}
      <div className='flex-1 flex flex-col items-center justify-start p-4 md:p-8 relative overflow-y-auto'>
        <img
          src={homeBackground}
          alt='homeBackground'
          className='absolute inset-0 w-full bg-cover bg-no-repeat z-0'
        />
        {/* Home Button - Top Right of left area */}
        <button
          onClick={() => navigate('/')}
          className='hidden xl:flex absolute top-8 right-8 items-center gap-2 px-4 py-2 text-sm font-medium text-[#334960] hover:text-[#001B38] rounded-lg transition-all duration-200 border border-gray-300 hover:border-gray-400 z-30'
          title='Go to Home'
        >
          <Home className='w-5 h-5' />
          <span>Home</span>
        </button>
        {/* Left Sidebar - Logo */}
        <div className='flex flex-row items-center justify-start w-full z-20 shrink-0'>
          <button
            onClick={() => navigate('/')}
            className='cursor-pointer hover:opacity-80 transition-opacity'
          >
            <img src={logo} alt='logo' className='max-h-12' />
          </button>
        </div>
        <div className='w-full max-w-md z-20 flex flex-col items-center justify-center flex-1 py-4'>
          {children}
        </div>
      </div>

      {/* Right Sidebar - Feature Carousel */}
      <div className='hidden xl:flex flex-col justify-center w-[480px] bg-[#EEF0F2] border-l border-gray-200 p-8 items-center relative overflow-hidden'>
        <div className='w-full flex flex-col items-start justify-center'>
          <div className='font-[700] text-[30px] text-[#181D27] text-start'>
            HMRC & Companies <br /> House Integration
          </div>
          <div className='text-[16px] font-[400] text-[#535862] text-start mt-2'>
            Cloud-based filing with direct submissions to HMRC and Companies
            House APIs for CT600, SA100, accounts, or confirmation statements.
          </div>
          <img src={ToggledImage} alt='Toggled' className='mt-4' />
        </div>
        <div className='mt-[63px] flex items-center justify-center'>
          <img
            src={loginDashboard}
            alt='loginDashboard'
            className='max-w-full h-auto'
          />
        </div>
      </div>
    </div>
  )
}
